import { mapActions, mapState } from "vuex";
import boolMixin from "@/mixins/boolMixin";

export default {
  mixins: [ boolMixin],
  props: {
    hasSubscriptions: {
        type: Boolean,
        required: false,
        default: false,
      },
    missingTypes: {
        type: Array,
        required: false,
        default: () => [],
    },
    roamingTypes: {
        type: Array,
        required: false,
        default: () => ["international_calls", "roaming", "extra_did"],
    },
  },
  computed: {
    ...mapState({
        user: (state) => state.user,
      }),
  },
  methods: {
    ...mapActions(["setDisplayExtraDids"]),
    serviceRoamingName(serviceStr) {
      let translation;
      switch (serviceStr) {
        case "international_calls":
          translation = "שיחות לחו״ל";
          break;
        case "roaming":
          translation = "נדידה בחו״ל";
          break;
        case "extra_did":
          translation = "מספרי חו״ל";
          break;
        default:
          translation = "";
          break;
      }
      return translation;
    },
    serviceName(serviceStr) {
      let translation;
      switch (serviceStr) {
        case "other":
          translation = "אחר";
          break;
        case "extra_did":
          translation = "מספר נוסף";
          break;
        case "full_service":
          translation = "שירות מלא";
          break;
        case "recording":
          translation = "הקלטה";
          break;
        case "netfree":
          translation = "נטפרי";
          break;
        case "international_calls":
          translation = "שיחות לחו״ל";
          break;
        case 'unblock_private_cid':
          translation = 'זיהוי מספר חסום'
          break
        case "roaming":
          translation = "נדידה בחו״ל";
          break;
        default:
          translation = "";
          break;
      }
      return translation;
    },
    contentForService(serviceStr) {
      let content;
      switch (serviceStr) {
        case "international_calls":
          content = '3000 דקות לארה"ב ואנגליה - 30 ש"ח לחודש';
          break;
        case "roaming":
          content = 'חבילה יומית - יום ראשון ללא תשלום - 18 ש"ח ליום';
          break;
        case "extra_did":
          content = ' 12165770770 - ארה"ב - 15 ש"ח לחודש';
          break;
        default:
          content = "";
          break;
      }
      return content;
    },
    openService(index) {
      // console.log('openService(index) ', index);
      switch (
        this.hasSubscriptions
          ? this.missingTypes[index]
          : this.roamingTypes[index]
      ) {
        case "roaming":
          // this.dataValue = true;
          this.$router.push(`/user/${this.user.profile.domain_user_id}/roaming/addRoaming`);
          break;
        case "extra_did":
          this.$router.push(`/user/${this.user.profile.domain_user_id}/roaming/addNumber`);
          // this.$store.dispatch("setDisplayExtraDids", true);
          // this.$router.push(`/user/${this.user.profile.domain_user_id}/dids`);
          break;
        case "international_calls":
          this.$router.push(`/user/${this.user.profile.domain_user_id}/roaming/addCalls`);
          // this.$emit('displayInternationalPack')
          break;
        default:
          return;
      }
    },
  },
};
